/**
 * JS handle course review
 *
 * @since 4.0.0
 * @version 1.0.2
 */
import * as lpUtils from './utils.js';
import Toastify from 'toastify-js';

const classLoadMore = 'course-review-load-more';
const classLPTarget = '.lp-target';
const classCourseReviewsList = '.course-reviews-list';
const classReviewStars = '.review-stars';
const classChooseStar = '.choose-star';
const loadMoreReview = ( e, target ) => {
	const btnLoadMore = target.closest(
		`.${ classLoadMore + ':not(.loading)' }`
	);
	if ( ! btnLoadMore ) {
		return;
	}

	lpUtils.lpSetLoadingEl( btnLoadMore, true );
	const elLPTarget = btnLoadMore.closest( `${ classLPTarget }` );
	if ( ! elLPTarget ) {
		return;
	}

	const dataObj = JSON.parse( elLPTarget.dataset.send );
	const dataSend = { ...dataObj };
	if ( ! dataSend.args.hasOwnProperty( 'paged' ) ) {
		dataSend.args.paged = 1;
	} else {
		dataSend.args.paged++;
	}
	elLPTarget.dataset.send = JSON.stringify( dataSend );

	const callBack = {
		success: ( response ) => {
			const { data } = response;

			const paged = parseInt( data.paged );
			const totalPages = parseInt( data.total_pages );

			const newEl = document.createElement( 'div' );
			newEl.innerHTML = data.content || '';
			const elListCourse = elLPTarget.querySelector(
				`${ classCourseReviewsList }`
			);

			elListCourse.insertAdjacentHTML(
				'beforeend',
				newEl.querySelector( `${ classCourseReviewsList }` ).innerHTML
			);

			if ( paged >= ( totalPages - 1 ) ) {
				btnLoadMore.remove();
			}
		},
		error: ( error ) => {
			console.log( error );
		},
		completed: () => {
			lpUtils.lpSetLoadingEl( btnLoadMore, false );
		},
	};

	window.lpAJAXG.fetchAJAX( dataSend, callBack );
};
const showFormReview = ( e, target ) => {
	const elBtnShowForm = target.closest( '.write-a-review' );
	if ( ! elBtnShowForm ) {
		return;
	}

	const form = document.querySelector( '.course-review-wrapper' );
	if ( ! form ) {
		return;
	}

	form.classList.add( 'active' );
};
const choiceStar = ( e, target ) => {
	const elChoiceStar = target.closest( `${ classChooseStar }` );
	if ( ! elChoiceStar ) {
		return;
	}

	const form = target.closest( 'form' );
	const elRatingChose = form.querySelector( 'input[name="rating"]' );
	if ( elRatingChose ) {
		elRatingChose.value = elChoiceStar.dataset.star;
	}
};
const closeFormReview = ( e, target ) => {
	const elClose = target.closest( '.close' );
	if ( ! elClose ) {
		return;
	}

	const elFormWrapper = elClose.closest( '.course-review-wrapper' );
	if ( ! elFormWrapper ) {
		return;
	}

	e.preventDefault();
	elFormWrapper.classList.remove( 'active' );
};
const submitFormReview = ( e, target ) => {
	const elBtnSubmit = target.closest( '.submit-review' );
	if ( ! elBtnSubmit ) {
		return;
	}

	const form = elBtnSubmit.closest( 'form.review-form' );
	if ( ! form ) {
		return;
	}

	e.preventDefault();

	lpUtils.lpSetLoadingEl( elBtnSubmit, 1 );

	const elLPTarget = elBtnSubmit.closest( `${ classLPTarget }` );
	if ( ! elLPTarget ) {
		return;
	}

	const dataObj = JSON.parse( elLPTarget.dataset.send );
	const dataSend = { ...dataObj };
	const formData = new FormData( form );
	for ( const pair of formData.entries() ) {
		const key = pair[ 0 ];
		const value = formData.getAll( key );
		if ( ! dataSend.args.hasOwnProperty( key ) ) {
			let value_convert = value;
			if ( 'object' === typeof value ) {
				value_convert = value.join( ',' );
			}
			dataSend.args[ key ] = value_convert;
		}
	}

	const callBack = {
		success: ( response ) => {
			const { data } = response;
			const { status, content } = data;

			Toastify( {
				text: content,
				gravity: lpData.toast.gravity, // `top` or `bottom`
				position: lpData.toast.position, // `left`, `center` or `right`
				className: `${ lpData.toast.classPrefix } ${ status }`,
				close: lpData.toast.close == 1,
				stopOnFocus: lpData.toast.stopOnFocus == 1,
				duration: lpData.toast.duration,
			} ).showToast();

			if ( 'success' === status ) {
				window.location.reload();
			}
		},
		error: ( error ) => {
			console.log( error );
		},
		completed: () => {
			lpUtils.lpSetLoadingEl( elBtnSubmit, false );
		},
	};

	window.lpAJAXG.fetchAJAX( dataSend, callBack );
};

// Events click
document.addEventListener( 'click', ( e ) => {
	const target = e.target;
	loadMoreReview( e, target );
	showFormReview( e, target );
	choiceStar( e, target );
	closeFormReview( e, target );
	submitFormReview( e, target );
} );

/**
 * Event mouseover
 *
 * Show rating when hover on star
 * Show rating choice when click on star
 */
document.addEventListener( 'mouseover', ( e ) => {
	const target = e.target;
	const elChooseStar = target.closest( `${ classChooseStar }` );
	if ( elChooseStar ) {
		const starNumber = parseInt( elChooseStar.dataset.star );
		const elReviewStars = elChooseStar.closest( `${ classReviewStars }` );
		for ( let i = 1; i < 6; i++ ) {
			const elReviewStar = elReviewStars.querySelector(
				'li[data-star="' + i + '"]'
			);
			const elReviewStarSpan = elReviewStar.querySelector( 'span' );
			if ( i <= starNumber ) {
				elReviewStarSpan.classList.add( 'hover' );
			} else {
				elReviewStarSpan.classList.remove( 'hover' );
			}
		}
	} else {
		const elReviewFields = document.querySelectorAll( '.review-fields' );
		if ( ! elReviewFields.length ) {
			return;
		}

		elReviewFields.forEach( ( elReviewField ) => {
			const elRatingChoice = elReviewField.querySelector(
				'input[name="rating"]'
			);
			const starChoice = elRatingChoice.value || 0;
			const elReviewStars = elReviewField.querySelector(
				`${ classReviewStars }`
			);

			for ( let i = 1; i < 6; i++ ) {
				const elReviewStar = elReviewStars.querySelector(
					'li[data-star="' + i + '"]'
				);
				const elReviewStarSpan = elReviewStar.querySelector( 'span' );
				if ( i <= starChoice ) {
					elReviewStarSpan.classList.add( 'hover' );
				} else {
					elReviewStarSpan.classList.remove( 'hover' );
				}
			}
		} );
	}
} );
